"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.axiosRequest = void 0;
const axios_1 = __importDefault(require("axios"));
const lodash_1 = __importDefault(require("lodash"));
const error_1 = require("./error");
async function axiosRequest(options) {
    try {
        const response = await (0, axios_1.default)(options);
        return response.data;
    }
    catch (error) {
        if (axios_1.default.isAxiosError(error)) {
            const Error = lodash_1.default.omit(error.toJSON(), 'config');
            if (error.response) {
                const smallerResponse = lodash_1.default.pick(error.response, ['data', 'status', 'statusText']);
                throw new error_1.AxiosServerError(smallerResponse, Error);
            }
            // request error or timeout error
            throw new error_1.AxiosError(`Axios: ${error.message}`, Error);
        }
        throw error;
    }
}
exports.axiosRequest = axiosRequest;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXhpb3MuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvbGliL2F4aW9zL2F4aW9zLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLGtEQUFrRDtBQUNsRCxvREFBdUI7QUFFdkIsbUNBQXlFO0FBRWxFLEtBQUssVUFBVSxZQUFZLENBQUMsT0FBMkI7SUFDNUQsSUFBSTtRQUNGLE1BQU0sUUFBUSxHQUFHLE1BQU0sSUFBQSxlQUFLLEVBQUMsT0FBTyxDQUFDLENBQUM7UUFDdEMsT0FBTyxRQUFRLENBQUMsSUFBSSxDQUFDO0tBQ3RCO0lBQUMsT0FBTyxLQUFLLEVBQUU7UUFDZCxJQUFJLGVBQUssQ0FBQyxZQUFZLENBQUMsS0FBSyxDQUFDLEVBQUU7WUFDN0IsTUFBTSxLQUFLLEdBQXFCLGdCQUFDLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxNQUFNLEVBQUUsRUFBRSxRQUFRLENBQUMsQ0FBQztZQUNqRSxJQUFJLEtBQUssQ0FBQyxRQUFRLEVBQUU7Z0JBQ2xCLE1BQU0sZUFBZSxHQUFxRCxnQkFBQyxDQUFDLElBQUksQ0FDOUUsS0FBSyxDQUFDLFFBQVEsRUFDZCxDQUFDLE1BQU0sRUFBRSxRQUFRLEVBQUUsWUFBWSxDQUFDLENBQ2pDLENBQUM7Z0JBQ0YsTUFBTSxJQUFJLHdCQUFnQixDQUFDLGVBQWUsRUFBRSxLQUFLLENBQUMsQ0FBQzthQUNwRDtZQUNELGlDQUFpQztZQUNqQyxNQUFNLElBQUksa0JBQVUsQ0FBQyxVQUFVLEtBQUssQ0FBQyxPQUFPLEVBQUUsRUFBRSxLQUFLLENBQUMsQ0FBQztTQUN4RDtRQUNELE1BQU0sS0FBSyxDQUFDO0tBQ2I7QUFDSCxDQUFDO0FBbkJELG9DQW1CQyJ9